module.exports = __webpack_public_path__ + "img/convenience-6-image.41d650ba.jpg";